import { App } from '@default/app';
import { ErrorBoundary, getCoreOptions, Loading } from '@libs/core';
import { ClearSessionPage } from '../pages/ClearSessionPage';
import { DeepLinkPage } from '../pages/DeepLinkPage';
import { AccessDeniedRoute } from './AccessDeniedRoute';
import { ACCESS_DENIED_PATH, accessDeniedLoader, rootLoader } from './loaders';

// Deep-link path prefixes from the package's core options (or the stand's `deepLinkPath` override), resolved at build time.
const arrayOfDeepLinks = getCoreOptions().navigation?.deepLinkPaths ?? [];

const router = [
    {
        path: '/',
        loader: rootLoader,
        shouldRevalidate: () => false,
        element: <App />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    },
    {
        path: ACCESS_DENIED_PATH,
        loader: accessDeniedLoader,
        element: <AccessDeniedRoute />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    },
    {
        path: '/clearSession',
        element: <ClearSessionPage />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    },
];
arrayOfDeepLinks.forEach((path) =>
    router.push({
        path: `${path}/*`,
        element: <DeepLinkPage />,
        errorElement: <ErrorBoundary />,
        hydrateFallbackElement: <Loading />,
    }),
);
router.push({
    path: '*',
    element: <>Not found</>,
    errorElement: <ErrorBoundary />,
    hydrateFallbackElement: <Loading />,
});

export default router;
